<style scoped>
  .extras-component{
    height: 100vh;
  }
  .app-base-layout{
    /* padding: 42px 0 75px 0 !important; */
  }
</style>

<template>
  <app-layout>
    <div class="extras-component">
      <iframe style="width: 100%; height: calc(100% - 148px); border: none;" :src="finUrl" v-if="extrasInfo.type == 'hybrid' && !loaded"></iframe>
      <FeedListComponent v-if="extrasInfo.type != 'hybrid'"></FeedListComponent>
    </div>
  </app-layout>
</template>

<script>
  import FeedListComponent from '@/views/FeedSingleComponent';
  import { mapGetters } from 'vuex';

  export default {
    name: 'ExtrasComponent',
    data() {
      return {
        finUrl: "",
        loaded: true 
      }
    },
    computed: {
      ...mapGetters("user", ["userInfo", "brandInfo"]),
      extrasInfo: {
        get() {
          return this.$store.state.feed.feedSingleItem
        }
      },
      extrasId() {
        return this.$route.params.id
      }
    },
    components: {
      FeedListComponent
    },
    methods: {
      loadExtras() {
        this.loaded = true;
        this.$store.commit("feed/setFeedSingleItem", {})
        this.$store.dispatch('feed/getFeedSingleItem', this.$route.params.id)
          .then(res => {
            let v = this.extrasInfo;
            let url = v.data.url;
            
            if (v.data.url.includes("{userId}")) {
              url = url.replace(/{userId}/g, this.userInfo.id);
            }

            if (this.brandInfo.generic_id) {
              if (
                this.brandInfo.generic_id.slug &&
                v.data.url.includes(`{${this.brandInfo.generic_id.slug}}`)
              )
                if (this.userInfo.generic_id) {
                  let rgx = `{${this.brandInfo.generic_id.slug}}`;
                  url = url.replace(rgx, this.userInfo.generic_id);
                } else
                  url = url.replace(
                    /[{generic_id}|{genericId}]/g,
                    this.userInfo.generic_id
                  );
                }

            if (v.data.url.includes("{appName}")) {
              url = url.replace(/{appName}/g, this.$route.params.brandSlug);
            }

            if (v.data.url.includes("{generic_id}") || v.data.url.includes("{genericId}")) {
              if (this.userInfo.generic_id) {
                url = url.replace(/[{generic_id}|{genericId}]/g, this.userInfo.generic_id);
              }
            } 

            this.finUrl = url;
            this.$store.commit('setPageTitle', res.title)
            this.loaded = false
          })
          .catch(e => {
            this.loaded = false
          })
      }
    },
    watch: {
      extrasId(n) {
        this.loadExtras()
      }
    },
    mounted(){
      this.loadExtras()
    }
  }
</script>
